const it = {
  forbidden_page: {
    message: 'Spiacenti, non sei autorizzato a vedere questa pagina.',
  },

  page_404: {
    message: '(404) Spiacenti, questa pagina non esiste.',
    click: 'Clicca',
    here: 'qui',
    to_return: 'per tornare alla home page.',
  },

  login_page: {
    digital: 'Digital',
    inspection_jacket: 'Inspection Jacket',
    logging_in: 'Accesso in corso...',
  },

  dashboard_page: {
    welcome: 'Benvenuto',
    intro: 'Soluzione end-to-end per l’ispezione digitale.',
    scan_project_code: 'Scansiona codice progetto',
    new_version_available: 'Nuova versione disponibile!',
    websocket_status: 'Stato WebSocket',
    dij_version: 'Digital Inspection Jacket {version}',
  },

  header: {
    app_name: 'Digital Inspection Jacket',
  },

  task_page: {
    create_new_task: 'Crea nuova attività',
    back_to_product_list:
      'Rilascia il file qui o fai clic per caricare l’immagine di riferimento',
    reference_image: 'Immagine di riferimento',
    signed_off_by: 'Approvato da {name}',
    task_not_available_offline: 'Attività non disponibile offline',
    need_help_chat: 'Hai bisogno di aiuto? Clicca qui per chattare!',
    loading_user_roles: 'Caricamento ruoli utente...',
    loading_job_details: 'Caricamento dettagli lavoro...',
    checking_job_status: 'Verifica stato lavoro...',
    loading_job_tasks: 'Caricamento attività lavoro...',
    deleting_task: 'Eliminazione attività...',
    duplicating_folder: 'Duplicazione cartella...',
    select_folder_to_move: 'Seleziona la cartella da spostare.',
    delete_folder_confirmation_message:
      'Eliminare una cartella eliminerà tutte le attività al suo interno.',
    delete_confirmation: 'Sei sicuro di voler eliminare?',
  },

  create_new_user_page: {
    create_new_user: 'Crea nuovo utente',
    create_user: 'Crea utente',
    firstName: 'Nome',
    lastName: 'Cognome',
    gid: 'GID',
    email: 'E-mail',
    password: 'Password',
    role: 'Ruolo',
    all_fields_required: 'Per favore, compila tutti i campi obbligatori.',
    user_failed: 'Creazione utente non riuscita.',
    user_success: 'Utente creato con successo.',
    password_validation:
      'Requisiti password: almeno 8 caratteri, una minuscola, una maiuscola, un numero, nessuna parte del tuo nome utente.',
  },

  change_password_page: {
    change_password: 'Cambia password',
    change_user_password: 'Cambia password utente',
    password_change_success: 'Password cambiata con successo',
    secret_question_success: 'Domanda segreta impostata con successo',
    password_change_fail: 'Impossibile cambiare la password.',
    secret_question_fail: 'Impossibile impostare la domanda segreta',
    email: 'E-mail',
    oldPassword: 'Vecchia password',
    password: 'Nuova password',
    confirmNewPassword: 'Conferma nuova password',
    password_should_match:
      'La nuova password e la conferma devono совпaciare.',
    password_validation:
      'Requisiti password: almeno 8 caratteri, una minuscola, una maiuscola, un numero, nessuna parte della tua e-mail.',
    passwordLowerCase: 'La password deve contenere almeno una lettera minuscola.',
    passwordUpperCase: 'La password deve contenere almeno una lettera maiuscola.',
    passwordNumber: 'La password deve contenere almeno una cifra.',
    passwordMinLength: 'La password deve contenere almeno 8 caratteri.',
    passwordNoUsernameParts:
      'La password non può contenere parti del nome utente.',
  },

  profile_page: {
    myProfile: 'Il mio profilo',
    account: 'Account',
    preferences: 'Preferenze',
    profileUpdated: 'Profilo aggiornato con successo',
    updatePreferences: 'Aggiorna preferenze',
    updateAccount: 'Aggiorna account',
    my_name: 'Il mio nome',
    username: 'Nome utente',
    email: 'E-mail',
    location: 'Sede',
    phone_number: 'Numero di telefono',
  },

  task_view: {
    cancel: 'Annulla',
    back: 'Indietro',
    save: 'Salva',
    delete: 'Elimina',
    deleteConfirmation:
      'Sei sicuro di voler <b>eliminare</b> l’attività <b>{taskTitle}</b>?',
    deleteTask: 'Elimina attività',
    manageMte: 'Registro strumentazione',
    repairAssessment: 'Valutazione riparazione',
    importAccuScan: 'Importa AccuScan',
    importLaserscan: 'Importa Laser Scan',
    signOff: 'Approva',
    orderItem: 'Ordina articolo',
  },

  text_size: 'Dimensione testo',
  selection: 'Selezione',
  alignedlength: 'Lunghezza allineata',
  linearlength: 'Lunghezza lineare',
  positive_tolerance: '+ Tolleranza',
  negative_tolerance: '- Tolleranza',

  product_template_list: 'Lista modelli prodotto',
  work_order_list: 'Lista ordini di lavoro',
  update: 'Aggiorna',
  order: 'Ordine',
  select_folder: 'Seleziona cartella',
  move: 'Sposta',
  add_task: 'Aggiungi attività',
  add_folder: 'Aggiungi cartella',
  add_field: 'Aggiungi campo',
  message_order_drag: 'Ora puoi ordinare le tue attività, basta trascinarle',
  move_folder: 'Sposta nella cartella',
  move_selected: 'Sposta selezionati',
  select: 'Seleziona',
  delete_selected: 'Elimina selezionati',

  admin: 'Admin',
  editor: 'Editor',
  publisher: 'Publisher',
  inspector: 'Ispettore',
  report: 'Report',
  dashboard: 'Dashboard',
  profile: 'Profilo',
  language: 'Lingua',
  view_profile: 'Visualizza profilo',
  manage_fleet_data: 'Gestisci dati flotta',
  report_issue: 'Segnala problema',
  request_content: 'Richiedi contenuto',
  contact_us: 'Contatti',
  forum: 'Forum Viva Engage',
  training: 'Formazione',
  log_out: 'Esci',

  choose_language: 'Scegli la tua lingua preferita.',

  create_new_product: 'Crea nuovo prodotto',
  title: 'Titolo',
  product_line: 'Linea prodotto',
  original_OEM: 'OEM originale',
  frame_type: 'Tipo di telaio',
  model: 'Modello',
  part_number: 'Numero parte',
  document_number: 'Numero documento',
  revision: 'Revisione',
  cancel: 'Annulla',
  submit: 'Invia',
  delete: 'Elimina',
  save: 'Salva',
  done: 'Fatto',
  new_product_success: 'Nuovo prodotto creato con successo.',
  new_product_fail_message:
    'Errore durante la creazione del nuovo lavoro! Riprova.',

  // Tool names inside diagram
  'Selection Tool': 'Strumento di selezione',
  'Pan Viewport': 'Panoramica',
  Diameter: 'Diametro',
  'Run-Out': 'Eccentricità',
  'Linear Length': 'Lunghezza lineare',
  'Visual Inspection': 'Ispezione visiva',
  Text: 'Testo',
  'Generic Measurement': 'Misurazione generica',
  Arrow: 'Freccia',
  Line: 'Linea',
  'Replace Image': 'Sostituisci immagine',

  // Bubble names
  generic: 'Marcatore generico',
  generic_name: 'Nome generico',
  runout: 'Eccentricità',
  length: 'Lunghezza',
  diameter: 'Diametro',
  arrow: 'Freccia',
  line: 'Linea',
  text: 'Testo',
  visualInspection: 'Ispezione visiva',

  // Bubble properties
  label_numbers_only: 'Etichetta (solo numeri)',
  expected_value: 'Valore atteso',
  decimals: 'Decimali',
  units: 'Unità',
  inch: 'pollici',
  mm: 'mm',
  tolerance_type: 'Tipo di tolleranza',
  tolerance: 'Tolleranza',
  multiple_positions: 'Più posizioni',
  edit_table: 'Modifica tabella',
  orientation: 'Orientamento',
  measurement_name: 'Nome misurazione',
  visual_name: 'Nome visuale',
  marker_description: 'Descrizione',
  generic_marker_tolerance: 'Tolleranza',
  direction: 'Direzione',
  degrees: 'Gradi',
  clock: 'Orologio',
  rotate_text: 'Ruota testo',
  rubbed: 'Sfregato',
  damaged: 'Danneggiato',
  pitted: 'Puntinato',
  eroded: 'Eroso',
  high: 'Alto',
  low: 'Basso',
  medium: 'Medio',
  acceptable: 'Accettabile',
  all: 'Tutti',
  position: 'Posizione',
  tir: 'TIR',
  ok: 'OK',
  in: 'pollici',
  iso_name: 'ISO',
  iso_grade: 'Grado ISO',
  RAT: 'RAT',
  none: 'Nessuno',

  // Save or discard dialog
  save_or_discard_dialog_content: 'Vuoi salvare le modifiche?',
  discard: 'Scarta',
  stay: 'Resta',
  back: 'Indietro',
  dismiss: 'Chiudi',

  import_drawing: 'Importa disegno',
  work_order_list: 'Lista ordini di lavoro',

  edit_name: 'Modifica nome',
  reopen: 'Riapri',

  //Instruction actions
  create_new_item: 'Crea nuovo elemento',
  choose_one_item: 'Scegli un elemento',
  order_item: 'Ordina elemento',
  action: 'Azione',
  yes_no: 'Sì/No',
  options: 'Opzioni',
  add_iso: 'Aggiungi ISO',
  add_calculation: 'Aggiungi calcolo',
  recover: 'Ripristina',
  loading: 'Caricamento...',
  clear_filters: 'Cancella filtri',
  job_downloaded_locally: 'Lavoro scaricato in locale',
  job_has_incomplete_data: 'Il lavoro ha dati incompleti',
  job_includes_repair_assessment: 'Il lavoro include valutazioni di riparazione',
  text: 'Testo',
  sap_reference: 'Riferimento SAP',
  filter: 'Filtro',
  current_owner: 'Proprietario attuale',
  current_owner_date: 'Proprietario attuale / Data',

  template_list: {
    retrieving_listings: 'Recupero elenchi in base alla tua ricerca...',
    fetched_pages_found:
      '{batchCount} pagine recuperate finora. Trovati {size} elenchi...',
    found_listings: 'Trovati {length} elenchi che corrispondono ai criteri di ricerca.',
    failed_to_fetch_listings: 'Impossibile recuperare gli elenchi',
  },

  table: 'Tabella',
  import_csv: 'Importa CSV',

  action_requested: 'Azione richiesta',
  picture_taken_is_mandatory: 'La foto è obbligatoria.',
  picture_uploaded_successfully: '{image} caricato con successo',
  picture_required: 'Immagine obbligatoria.',
  your_question: 'La tua domanda',
  question: 'Domanda',
  options: 'Opzione',
  add_an_option: 'Aggiungi un’opzione',
  multiple_choice: 'Scelta multipla',
  text_or_number: 'Testo o numero',

  number_of_rows: 'Numero di righe',
  number_of_columns: 'Numero di colonne',
  edit_rows: 'Modifica righe',
  edit_columns: 'Modifica colonne',
  only_numbers_and_alphabets:
    'Sono consentiti solo numeri e lettere fino a 16 caratteri in una cella',
  table_headings_not_empty: 'Le intestazioni della tabella non possono essere vuote',
  upload_diagram: 'Carica diagramma',

  yes: 'Sì',
  no: 'No',

  product_template_list: 'Lista modelli prodotto',
  product_line: 'Linea prodotto',
  work_order_list: 'Lista ordini di lavoro',
  favorite_list: 'Lista preferiti',
  search: 'Cerca',
  add_product: 'Aggiungi prodotto',
  title: 'Titolo',
  original_OEM: 'OEM originale',
  frame_type: 'Tipo di telaio',
  model: 'Modello',
  part_number: 'Numero parte',
  location: 'Sede',
  document_number: 'Numero documento',
  revision: 'Revisione',
  created_by: 'Creato da',
  date: 'Data',
  edit: 'Modifica',
  delete: 'Elimina',
  duplicate: 'Duplica',
  copyfrom: 'Copia da',
  nothing_here: 'Niente qui',

  project_number: 'Numero progetto',
  customer: 'Cliente',
  work_order_number: 'Numero ordine di lavoro',
  serial_number: 'Numero di serie',
  sales_force_number: 'Numero Sales Force',
  add_order: 'Aggiungi ordine',
  edit_order: 'Modifica ordine',
  original_oem_number: 'Numero OEM originale',
  freefinding: 'Rilevamento libero',

  part_level: 'Livello parte',

  new_product_success_message: 'Nuovo prodotto creato con successo!',
  new_product_fail_message:
    'Errore durante la creazione del nuovo lavoro! Riprova.',

  task_count: 'Numero attività',
  selection_from_list: 'Se desiderato, seleziona dalla lista',
  select_tasks: 'Seleziona attività',
  select_products: 'Seleziona prodotti (opzionale)',

  select_all: 'Seleziona tutto',
  deselect_all: 'Deseleziona tutto',
  select_site: 'Seleziona sito',
  selected_products: 'Prodotti selezionati',
  review: 'Revisione',
  sites: 'Siti secondari',
  products: 'Prodotti',
  tasks: 'Attività',
  next: 'Avanti',

  sign_off: 'Approva',
  sign_off_questions_completed: '{completed}/{total} completato/i.',
  sign_off_diagram_completed: 'Diagramma {percent}% completato.',
  sign_off_comments_label: 'Inserisci qui i tuoi commenti...',
  number_of_measurement_points: 'Numero di punti di misura',
  stage: 'Fase',
  number_of_stages: 'Numero di fasi',
  add_job_with_table_message:
    'Spiacenti, non puoi aggiungere nuovi lavori perché hai selezionato un lavoro con una tabella attività al suo interno.',
  configure_table_order: 'Configura tabella',
  version: 'Versione',
  task_completed_message:
    'Attività già approvata! Riapri per ulteriori modifiche!',

  create_task: {
    create_new_task: 'Crea nuova attività',
    diagram: 'Diagramma',
    instruction: 'Istruzione',
    worksheet: 'Foglio di lavoro',
    task_name: 'Nome attività',
    cancel: 'Annulla',
    done: 'Fatto',
    select_software_tool: 'Seleziona strumento software',
  },

  create_folder: {
    create_new_folder: 'Crea nuova cartella',
    folder_name: 'Nome cartella',
    select_software_tool: 'Seleziona strumento software',
    configure_new_part: 'Configura nuova parte',
    draw_no_b_plan: 'N. disegno (B-Plan)',
    draw_no: 'N. disegno',
    draw_no_turbinenlaufer: 'N. disegno (Turbinenlaufer)',
    draw_no_nutenplan: 'N. disegno (Nutenplan)',
    draw_no_welle_vorne: 'N. disegno (Wellenende vorne)',
    draw_no_welle_hinten: 'N. disegno (Wellenende hinten)',
    draw_no_einstromteil: 'N. disegno (Einstromteil)',
    draw_no_abstromteil: 'N. disegno (Abstromteil)',
    rotor_id: 'ID rotore',
    parts_list: 'Lista parti',
    hallmark: 'Marchio',
    delete_title: 'ELIMINA',
    delete_field_confirmation: 'Eliminare il campo {label}?',
    name_prompt: 'Nome',
    field_already_exists: 'Il campo esiste già.',
    failed_create_task: 'Creazione della nuova attività non riuscita',
  },

  emfProductList: {
    workOrderList: 'Lista ordini di lavoro',
    search: 'Cerca',
    addOrder: 'Aggiungi ordine',
    next: 'Avanti',
    previous: 'Indietro',

    productLine: 'Linea prodotto',
    title: 'Titolo',
    originalOEM: 'OEM originale',
    frameType: 'Tipo di telaio',
    model: 'Modello',
    partNumber: 'Numero parte',
    customer: 'Cliente',
    projectNumber: 'N. progetto',
    serialNumber: 'N. serie',
    workOrder: 'Ordine di lavoro',
    salesForce: 'N. opportunità Sales Force',
    createdBy: 'Creato da',
  },

  loginSession: {
    admin: 'Amministratore',
    editor: 'Editor',
    publisher: 'Publisher',
    inspector: 'Ispettore',
    report: 'Report',
    dashboard: 'Dashboard',
    language: 'Lingua',
    profile: 'Profilo',
    viewProfile: 'Visualizza profilo',
    manageFleetData: 'Gestisci dati flotta',
    reportIssue: 'Segnala problema',
    requestContent: 'Richiedi contenuto',
    contactUs: 'Contatti',
    training: 'Formazione',
    logOut: 'Esci',
  },

  404: 'Non trovato',

  table_template: {
    create_table: 'Crea tabella',
    new_column: 'Aggiungi nuova colonna',
    new_row: 'Aggiungi nuova riga',
    delete_column: 'Elimina colonna selezionata',
    delete_row: 'Elimina riga selezionata',
  },

  calculation: {
    sum: 'Somma',
    sub: 'Sottrai',
    mult: 'Moltiplica',
  },

  duplicate_work_order_number: 'Il numero dell’ordine di lavoro è già in uso',
  view_qr_code: 'Visualizza QR Code',
  download_qr_code: 'Scarica QR Code',
  download_traveler: 'Scarica Traveler',
  include_repair_assessment: 'Includi valutazione riparazione',
  repair_assessment: 'Valutazione riparazione',
  import: 'Importa',
  import_editor_template: 'Modelli esistenti',
  import_add_excel_file: 'Aggiungi da file Excel',
  download_excel_file: 'Scarica file modello',
  export_task: 'Esporta attività',
  saved: 'Salvato',
  not_saved: 'Non salvato',
  level: 'Livello',
  assembly: 'Assieme',
  item_number: 'Numero elemento',
  part_name: 'Nome parte',
  part_number: 'Numero parte',
  quantity: 'Quantità',
  serialNumber: 'Numero di serie',
  actions: 'Azioni',
  no_records: 'Nessun record',
  repair_assessment_empty:
    'La valutazione di riparazione è vuota. Inizia importando dati o aggiungendoli manualmente',
  repair_assessment_empty_readonly: 'La valutazione di riparazione è vuota.',
  close: 'Chiudi',
  close_notification: 'Chiudi notifica',
  import_add: 'Importa',
  change_log: 'Registro modifiche',

  add_row: 'Aggiungi riga',
  remove_row: 'Rimuovi riga',

  repair_assessment_excel_import_failed:
    'Importazione della valutazione di riparazione dal file Excel non riuscita',

  reuse: 'Riutilizza',
  repair: 'Ripara',
  replace: 'Sostituisci',
  missing: 'Mancante',
  client_reject: 'Rifiuto cliente',
  received: 'Ricevuto',
  quality_control_override: 'CQ',
  reviewed: 'Revisione ing.',
  comments: 'Commenti',

  findings: 'Rilievi',
  recommendations: 'Raccomandazioni',

  visual: 'Visivo',
  dim: 'Dim',
  ndt: 'NDT',

  summary: 'Riepilogo',
  repair_scope: 'Ambito di riparazione',
  estimated_labor: 'Ore stimate',

  not_repair_engineer: 'Solo gli ingegneri possono revisionare',

  pre_assembly_audit: 'Audit pre-assemblaggio',
  donwload_rat: 'Esporta componenti',
  repair_assessment_search_empty: 'Nessun elemento disponibile.',

  delete_all: 'Elimina tutto',
  delete_all_message:
    'Questo eliminerà tutte le informazioni relative alla valutazione di riparazione.',
  delete_major_message:
    'Questo eliminerà le informazioni sui componenti principali relative alla valutazione di riparazione.',
  delete_minor_message:
    'Questo eliminerà le informazioni sui componenti secondari relative alla valutazione di riparazione.',

  repair_assessment_row_locked: 'Questa riga è bloccata da {user}',

  feature_disabled: 'Questa funzione è disabilitata nella tua sede',

  locations: 'Sedi',

  recycle_bin: 'Cestino',
  recycle_bin_empty: 'Il cestino è vuoto',

  task_name: 'Nome',
  task_type: 'Tipo',
  deleted_by: 'Eliminato da',
  deleted_at: 'Eliminato il',

  executing_site: 'Sede esecutiva',

  na: 'N/D',

  owner: 'Proprietario',

  mtetype_create_title: 'Crea tipo MTE',
  mtetype_update_title: 'Aggiorna tipo MTE',

  create: 'Crea',

  name: 'Nome',
  needs_master: 'Richiede master',
  is_master: 'È master',

  mte_type_delete_question: 'Sei sicuro di voler eliminare questo tipo MTE?',
  mte_type_delete_success: 'Tipo MTE eliminato con successo',
  mte_type_delete_fail: 'Impossibile eliminare il tipo MTE',

  mte_management: 'Registro strumentazione',
  add_using_camera: 'Aggiungi usando la fotocamera',
  close_camera: 'Chiudi fotocamera',
  add_manual_entry: 'Aggiungi voce manualmente',

  id: 'ID',
  type: 'Tipo',
  due_date: 'Data di scadenza',
  master: 'Master',
  created_at: 'Creato il',

  masters: 'Master',
  non_masters: 'Altri',

  mandatory_error_message: '{field} è obbligatorio',
  mandatory_date_must_not_be_in_past_error_message:
    '{field} è obbligatorio e non può essere nel passato',
  unique_error_message: '{field} deve essere unico',

  task_locked_by_user: 'L’attività è bloccata dall’utente {user} fino a {date}',

  clear: 'Pulisci',
  surrogate: 'Sostituto',
  stop_surrogating: 'Interrompi sostituzione',

  create_new_site_page: {
    siteName: 'Nome sito',
    city: 'Città',
    state: 'Stato',
    country: 'Paese',
    create_new_site: 'Crea nuovo sito',
    all_fields_required: 'Per favore, compila tutti i campi obbligatori.',
    site_failed: 'Creazione sito non riuscita.',
    site_success: 'Sito creato con successo.',
  },

  edit_site_page: {
    edit_site: 'Modifica sito',
    siteName: 'Nome sito',
    city: 'Città',
    state: 'Stato',
    country: 'Paese',
    rat: 'Modello valutazione riparazione',
    mte_m: 'Registro strumentazione',
    delete: 'Elimina',
    update: 'Aggiorna',
    successMessage: 'Sito aggiornato con successo.',
    failedMessage: 'Aggiornamento sito non riuscito.',
    delete_confirm: 'Sei sicuro di voler eliminare questo sito?',
    deletesite: 'Sito eliminato con successo.',
    deletefail: 'Impossibile eliminare il sito.',
  },
  site_list: {
    siteName: 'Nome sito',
    city: 'Città',
    state: 'Stato',
    country: 'Paese',
    DateModified: 'Data modifica',
  },
  announcement_banner: {
    title: 'Banner annuncio',
    description: 'Configura il banner annuncio.',
    status: 'Stato',
    message: 'Messaggio',
    start_date: 'Data di inizio',
    end_date: 'Data di fine',
    clear_action: 'Pulisci',
    preview_action: 'Anteprima',
    save_action: 'Salva',
    enabled_status: 'Abilitato',
    disabled_status: 'Disabilitato',
    clear_question:
      'Questo disabiliterà il banner di notifica per tutti gli utenti. Continuare?',
    end_date_error: 'La data di fine deve essere nel futuro',
  },
  edit_user_profile: {
    title: 'Profilo utente',
    user_owned_template_count: 'Questo utente possiede {count} modelli',
    user_owned_job_count: 'Questo utente possiede {count} lavori',
    reassign_jobs: 'Riassegna lavori',
    reassign_templates: 'Riassegna modelli',
    reassign_jobs_cancel: 'Annulla riassegnazione',
    pending_approval_message:
      'Questo utente è in attesa di approvazione. Verifica le informazioni utente e approva il profilo affinché l’utente possa usare DIJ',
    rejected_message:
      'Questo utente è stato rifiutato e non può accedere a DIJ. L’utente può comunque essere approvato se necessario.',
    success_message: 'Utente aggiornato con successo',
    full_name: 'Nome completo',
    email: 'E-mail',
    primary_location: 'Sede principale',
    secondary_locations: 'Sedi secondarie',
    phone_number: 'Numero di telefono',
    role: 'Ruolo',
    power_admin_role: 'Power Admin',
    placeholder_role: 'Ruolo',
    ownership: 'Proprietà',
    additional_permissions: 'Permessi aggiuntivi',
    enginner_review_permission: 'Revisione ingegneristica',
    delete_button: 'Elimina',
    update_button: 'Aggiorna',
    approve_button: 'Approva',
    reject_button: 'Rifiuta',
    cancel_button: 'Annulla',
    approve_question:
      'Stai approvando l’utente {name} con ruolo "{role}" e sedi "{locations}". Continuare?',
    reject_question:
      'Stai rifiutando {name}. L’utente non potrà usare DIJ. Continuare?',
    approve_success_message: 'Utente approvato con successo',
    reject_success_message: 'Utente rifiutato con successo',
    update_success_message: 'Informazioni utente aggiornate con successo',
    job_reassignment_success_message:
      'I modelli di questo utente sono stati riassegnati con successo',
  },
  new_user_welcome_page: {
    welcome_configurator_message:
      'Benvenuto in DIJ. Seleziona i siti rilevanti per il tuo lavoro',
    pending_approval_part1_message:
      'La tua richiesta di accesso è in attesa di approvazione.',
    pending_approval_part2_message: 'Torna più tardi per l’accesso.',
    submit: 'Invia',
  },
  user_list: {
    name: 'Nome completo',
    email: 'E-mail',
    location: 'Sede',
    role: 'Ruolo',
    last_login: 'Ultimo accesso',
  },
  users: {
    approved: 'Approvato',
    approved_description:
      'Elenco degli utenti approvati. Questi utenti hanno pieno accesso a DIJ.',
    pending_approval: 'Approvazione in sospeso',
    pending_approval_description:
      'Elenco degli utenti da approvare. Questi utenti non possono accedere a DIJ finché il loro profilo non viene approvato.',
    todays_logins: 'Accessi di oggi',
    todays_logins_description:
      'Elenco degli utenti che hanno effettuato l’accesso oggi. Si azzera ogni giorno a mezzanotte.',
    rejected: 'Rifiutato',
    rejected_description:
      'Elenco degli utenti rifiutati durante il processo di approvazione. Questi utenti non sanno di essere stati rifiutati.',
  },
  user_picker: {
    label: 'Seleziona utente',
    placeholder: 'Digita e seleziona utenti disponibili',
    no_match_found: 'Nessuna corrispondenza trovata',
    email: 'E-mail',
    role: 'Ruolo',
  },

  sign_off_instruction_not_completed:
    'Alcune istruzioni nell’attività non sono state completate. Sei sicuro di voler approvare l’attività? Questo bloccherà future modifiche.',
  sign_off_diagram_not_completed:
    'Alcuni punti di ispezione nell’attività non sono stati completati. Sei sicuro di voler approvare l’attività? Questo bloccherà future modifiche.',

  chat_box: {
    generated_content_warning:
      'Il contenuto è generato automaticamente dall’IA e può contenere imprecisioni',
    type_message_placeholder: 'Digita il tuo messaggio...',
    send: 'Invia',
    regenerate: 'Rigenera',
    please_wait: 'Attendere...',
    clear_local_history: 'Cancella cronologia locale',
    click_to_copy: 'Clicca per copiare',
  },
  report_template: {
    project_title: 'Titolo del progetto',
    enter_project_number: 'Inserisci il numero del progetto',
    customer: 'Cliente',
    enter_customer_information: 'Inserisci le informazioni del cliente',
    customer_tag: 'Tag cliente',
    enter_customer_tag: 'Inserisci il tag cliente',
    customer_po_no: 'N. ordine cliente',
    unit_serial: 'N. seriale unità',
    enter_serial_info: 'Inserisci il numero seriale',
    unit_model: 'Modello unità',
    project_number: 'Numero progetto',
    sales_force_opportunity_number: 'N. opportunità Sales Force',
    enter_sales_force_opportunity_number:
      'Inserisci il n. opportunità Sales Force',
    process: 'Processo',
    enter_process: 'Inserisci il processo',
    original_order_no: 'N. ordine originale',
    enter_original_order_no: 'Inserisci il n. ordine originale',
    previous_orders: 'Ordini precedenti',
    enter_previous_orders: 'Inserisci ordini precedenti',
    contact_person_name: 'Nome della persona di contatto',
    enter_contact_person_name: 'Inserisci il nome del contatto',
    contact_person_department: 'Reparto della persona di contatto',
    executive_summary: 'Sintesi esecutiva',
    generate_executive_summary: 'Genera sintesi esecutiva',
    repair_select: 'Selezione riparazione',
    sample_text: 'Testo di esempio:',
    sample_text_content:
      'Siemens ha fornito servizi tecnici per conto di Duke Energy Carolinas LLC per ispezionare e consigliare raccomandazioni di riparazione per un rotore EMM32A3N. Il gruppo rotore è stato inviato allo stabilimento di riparazione Siemens a Charlotte, North Carolina, per l’ispezione in ingresso.',
    revision_description: 'Descrizione revisione',
    enter_revision_description: 'Inserisci la descrizione della revisione',
    csm: 'CSM',
    enter_csm: 'Inserisci CSM',
    repair_engineer: 'Ingegnere di riparazione',
    enter_repair_engineer: 'Inserisci l’ingegnere di riparazione',
    major_components: 'Componenti principali',
    minor_components: 'Componenti secondari',
    work_performed_fact_finding:
      'Lavoro svolto per ispezione di accertamento',
    work_performed_repair: 'Lavoro svolto per riparazione',
    repairs_not_completed_recommendations_upgrades:
      'Riparazioni non completate, raccomandazioni e upgrade',
    appendix: 'Appendice',
  },

  report_header: {
    internal_report: 'Report interno',
    customer_report: 'Report cliente',
    exclude_items: 'Escludi elementi',
    documents: 'Documenti',
    revisions: 'Revisioni',
    description: 'Descrizione: {description}',
    download: 'Scarica',
    header: 'Intestazione',
    deviation_report: 'Report deviazione',
    repair_assessment: 'Valutazione riparazione',
    work_performed: 'Lavoro svolto',
    deleting_report_revision: 'Eliminazione revisione report',
    delete_revision_confirmation:
      'Sei sicuro di voler <b>eliminare</b> la revisione: {fileName}, descrizione: {description}? Questa azione non può essere annullata.',
    delete_revision: 'Elimina revisione',
  },

  report_tasks: {
    table: 'TABELLA',
    form_inspection: 'ISPEZIONE MODULO',
    document_number: 'Numero documento:',
    revision: 'Revisione:',
    no_records: 'Nessun record',
    item: 'ELEMENTO',
    answer: 'RISPOSTA',
    attachments_uc: 'ALLEGATO/I',
    inspector: 'ISPETTORE',
    date: 'DATA',
    inspection_diagram: 'DIAGRAMMA ISPEZIONE',
    length_measurements: 'MISURE LUNGHEZZA',
    diameter_measurements: 'MISURE DIAMETRO',
    visual_inspection: 'ISPEZIONE VISIVA',
    generic_measurements: 'MISURE GENERICHE',
    label_uc: 'Etichetta',
    part_name_uc: 'Nome parte',
    description_uc: 'Descrizione',
    question_label: 'Domanda:',
    name_label: 'Nome:',
    description_label: 'Descrizione:',
    expected_value_uc: 'Valore atteso',
    tolerance1: 'Tolleranza1',
    tolerance2: 'Tolleranza2',
    unit: 'Unità',
    inspector_title: 'Ispettore',
    date_title: 'Data',
    condition: 'Condizione',
    severity: 'Severità',
    measurement_name_uc: 'Nome misurazione',
    runout_measurements: 'MISURE ECCENTRICITÀ',
    tir: 'TIR',
    tolerance: 'Tolleranza',
    task_prefix: 'Attività:',
    show_oot_colors: 'Mostra colori fuori tolleranza',
    free_finding: 'RILIEVO LIBERO',
    attachments_plain: 'ALLEGATI',
    pictures: 'foto',
    excluded: 'esclusi',
  },

  deviation_report: {
    unit_serial: 'N. seriale unità:',
    review_only: 'Solo revisione',
    action_required: 'Azione richiesta',
    assembly_bom: 'Distinta base assieme',
    assembly_ref: 'Rif. assieme',
    item_number: 'N. elemento',
    original_pn: 'PN originale',
    actions: 'Azioni',
  },

  external_data: {
    title: 'DATI ESTERNI',
    upload_failed: 'Caricamento file non riuscito',
    item_uc: 'ELEMENTO',
    file_name: 'Nome file',
    print_to_report: 'Stampa nel report',
    file_type_error: 'Questo tipo di file non può essere stampato nel report',
    delete: 'Elimina',
  },

  findings: {
    title: 'RILIEVI',
    by_inspector: 'Da ispettore',
    by_reporter: 'Da redattore',
    placeholder: 'Inserisci qui i tuoi rilievi...',
  },
};

export default it;
